import { render, staticRenderFns } from "./BackUser.vue?vue&type=template&id=fcb78d22"
import script from "./BackUser.vue?vue&type=script&lang=js"
export * from "./BackUser.vue?vue&type=script&lang=js"
import style0 from "./BackUser.vue?vue&type=style&index=0&id=fcb78d22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports